import { Stack } from "@mui/material";
import PlayerItemEnhanced from "./PlayerItemEnhanced";
import EmptyCard from "./EmptyCard";

interface ProColorMapping {
  PROS: Record<number, [string, string]>;
  PLAYERS: Record<number, number>;
  MAPPING: Record<number, string>;
}

interface QuickAssignTarget {
  chukker: string;
  team: string;
  label: string;
}

interface PlayerListEnhancedProps {
  managerMode: number;
  playerList: Record<string, any[]>;
  team: string;
  chukker: string;
  useUSPARating: boolean;
  isBench: boolean;
  proColorMapping?: ProColorMapping;
  betaMode: boolean;
  onQuickAssign?: (playerId: string, sourceChukker: string, sourceTeam: string, targetChukker: string, targetTeam: string) => void;
  getAvailableTargets?: (currentChukker: string, currentTeam: string) => QuickAssignTarget[];
}

function PlayerListEnhanced(props: PlayerListEnhancedProps) {
  if (Object.entries(props.playerList).length === 0) {
    return <EmptyCard />;
  }

  // Get available targets for quick assign if function is provided
  const availableTargets = props.getAvailableTargets
    ? props.getAvailableTargets(props.chukker, props.team)
    : [];

  return (
    <Stack spacing={1}>
      {Object.entries(props.playerList).map(([key, players]) => {
        return (
          <PlayerItemEnhanced
            id={key}
            key={key}
            managerMode={props.managerMode}
            index={players[3]}
            firstName={players[4]}
            lastName={players[5]}
            rating={props.useUSPARating ? players[6] : players[7]}
            chukker={props.chukker}
            team={props.team}
            isBench={props.isBench}
            proColorMapping={props.proColorMapping}
            betaMode={props.betaMode}
            onQuickAssign={props.onQuickAssign}
            availableTargets={availableTargets}
          />
        );
      })}
    </Stack>
  );
}

export default PlayerListEnhanced;

